export default __webpack_public_path__ + "static/media/butter.7ca9446c.png";